import React, { useMemo } from "react";
import { TableSection } from "features/Research/v2/components/StockDetailPage/StockDetailPage.styles";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  ShowMoreButton,
} from "./RecentTransactions.styles";
import { columns } from "./columns";
import PropTypes from "prop-types";
import { getStockCompanyIcon } from "utils/index";
import { Table } from "components/Table";
import { useAuthorOrderHistory } from "features/Strategy/hook";

const RecentTransactions = ({ strategyId: propStrategyId }) => {
  const strategyId = propStrategyId;

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useAuthorOrderHistory(strategyId);

  const transactions = useMemo(() => {
    if (!data?.pages) return [];

    return data.pages.flatMap(
      (page) =>
        page.data?.map((item) => {
          return {
            ...item,
            id: item.order_id,
            asset: {
              symbol: item.universal_symbol?.symbol || "--",
              name: item.universal_symbol?.symbol || "--",
              imageUrl: getStockCompanyIcon(item.universal_symbol?.symbol),
            },
            type: item.action === "BUY" ? "Buy" : "Sell",
            executionPrice: item.execution_price || 0,
            shares: item.filled_quantity || item.quantity || 0,
            total:
              item.action === "SELL"
                ? -Math.abs(item.total || 0)
                : Math.abs(item.total || 0),
            date: item.date || "N/A",
          };
        }) || []
    );
  }, [data]);

  const handleLoadMore = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  if (data?.pages?.flatMap((page) => page.data || []).length === 0) return null;

  return (
    <TableSection>
      <Card>
        <CardHeader>
          <CardTitle>Recent transactions</CardTitle>
          {hasNextPage && (
            <ShowMoreButton
              onClick={handleLoadMore}
              disabled={isFetchingNextPage || isLoading}
            >
              {isFetchingNextPage || isLoading ? "Loading..." : "Show more"}
            </ShowMoreButton>
          )}
        </CardHeader>
        <CardContent>
          <Table
            data={transactions}
            columns={columns}
            isLoading={isLoading}
            isSubLoading={isFetchingNextPage}
            notFoundText="No recent transactions data available"
            showPagination={false}
            initialPageSize={Math.max(transactions.length, 15)}
          />
        </CardContent>
      </Card>
    </TableSection>
  );
};

RecentTransactions.propTypes = {
  strategyId: PropTypes.string,
};

export default RecentTransactions;
